import { ParseDateFilter as filter } from 'ecx.saigon.ui.common';
import { DATE_DISPLAY_FORMAT } from '../utils/constants';

/**
 * Invoke the common ParseDateFilter with defaults defined for the settlement
 * application
 *
 * @param value The date to parse
 * @returns {*}
 */
export default (value) => {
  return filter(value, undefined, DATE_DISPLAY_FORMAT);
};
